import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/CourseCard.scss";

const CourseCard = ({ course }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/courses?subject=${course.id}`);
  };

  return (
    <div className="course-card" onClick={handleClick}>
      <div className="course-card-body">
        <h3 className="course-title">{course.title}</h3>
        <p className="course-description">{course.description}</p>
      </div>
      <div className="course-card-footer">
        <div className="course-id">{course.id}</div>
        <button className="view-course-btn">View Topics →</button>
      </div>
    </div>
  );
};

export default CourseCard;
